import styled from 'styled-components'
import { IconComponent, themeColor, themeFontFamily } from 'LibNeo'

export const BodyTwoStyle = styled.div`
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	font-family: ${themeFontFamily('SBSansText')};
	color: ${themeColor('extraBackground3')};
`

export const UnsignedOrdersHeaderStyle = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	width: 100%;
	justify-content: space-between;
`

export const UnsignedOrdersIconCloseStyle = styled(IconComponent)`
	width: 32px;
	height: 32px;
	svg {
		width: 32px;
		height: 32px;
		fill: ${themeColor('gray', 8)};
	}
`

export const UnsignedOrdersModalStyle = styled.div`
	padding: 8px;
	display: flex;
	flex-direction: column;
	gap: 32px;
	align-items: flex-start;
`

export const UnsignedOrdersTextStyle = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`
